

namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsMemberDialog extends Serenity.EntityDialog<PsMemberRow, any> {
        from: any;
        protected getFormKey() { return PsMemberForm.formKey; }
        protected getIdProperty() { return PsMemberRow.idProperty; }
        protected getLocalTextPrefix() { return PsMemberRow.localTextPrefix; }
        protected getNameProperty() { return PsMemberRow.nameProperty; }
        protected getService() { return PsMemberService.baseUrl; }
        protected getDeletePermission() { return PsMemberRow.deletePermission; }
        protected getInsertPermission() { return PsMemberRow.insertPermission; }
        protected getUpdatePermission() { return PsMemberRow.updatePermission; }

        protected form = new PsMemberForm(this.idPrefix);
        constructor() {
            super();
            if (this.isNew) {
                this.form.MbAddress.changeSelect2(e => {
                    var add = Q.toId(this.form.MbAddress.value);
                    if (add != null) {

                        this.form.MbLineAddr1.value = this.form.MbAddress.value;

                    }
                });
                this.form.MbTumbol.changeSelect2(e => {
                    var add = Q.toId(this.form.MbTumbol.value);
                    if (add != null) {

                        this.form.MbLineAddr2.value = this.form.MbTumbol.value + "  " + this.form.MbAmphur.value;

                    }
                });
                this.form.MbAmphur.changeSelect2(e => {
                    var add = Q.toId(this.form.MbAmphur.value);
                    if (add != null) {

                        this.form.MbLineAddr2.value = this.form.MbTumbol.value + "  " + this.form.MbAmphur.value;

                    }
                });
                this.form.MbProvince.changeSelect2(e => {
                    var add = Q.toId(this.form.MbProvince.value);
                    if (add != null) {

                        this.form.MbLineAddr3.value = this.form.MbProvince.value + "  " + this.form.MbZipCode.value;

                    }
                });
                this.form.MbZipCode.changeSelect2(e => {
                    var add = Q.toId(this.form.MbZipCode.value);
                    if (add != null) {

                        this.form.MbLineAddr3.value = this.form.MbProvince.value + "  " + this.form.MbZipCode.value;

                    }
                });
            }
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            if(this.isNew()){
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                console.log('User Id : ' + userId.ShopId);

                this.form.MbExpireDate.value = new Date(new Date().setDate(new Date().getDate() + 365)).toString();
                try {
              this.form.ApplyShopId.value = userId.ShopId;
            } catch (e) {}
            }

            var Colorid = Q.tryFirst(PosShift.PosTranHdRow.getLookup().items,x => x.MbId == this.entity.MbId);
            if(Colorid !=null){
                this.deleteButton.toggleClass('disabled', true);
               
            }
            var Plucheck = Q.tryFirst(PosShift.PsTaxInvoiceAddressRow.getLookup().items, x=> x.MbId == this.entity.MbId);            
            if (Plucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
               
                
            }
        }

        

        protected updateInterface() {
            super.updateInterface();
            if (!this.isNew()) {
                if (this.entity.MbId) {
                    if (this.form.MbId.element.attr("readonly")) {
                        Serenity.EditorUtils.setReadonly(this.form.MbApplyDate.element, true);
                        Serenity.EditorUtils.setReadonly(this.form.MbAccumPoint.element, true);
                        //StockCostValue VatType
                    }
                    //Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                    //this.element.find('sup').hide();
                    //this.deleteButton.hide();


                }


            }
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            // buttons.push(
            //     {
            //         title: 'อ่านบัตรประชาชน',
            //         cssClass: 'read-card-button',
            //         icon: 'fa-id-card',
            //         hint: 'ctrl+i',
            //         hotkey: 'ctrl+i',
            //         onClick: () => {
            //             this.readCard();
            //         }
            //     }
            // );
            
            // buttons.push(
            //     {
            //         title: 'ทดสอบ',
            //         cssClass: 'read-card-button',
            //         icon: 'fa-id-card',
            //         hint: 'ctrl+i',
            //         hotkey: 'ctrl+i',
            //         onClick: () => {
            //             this.onClickReadCard();
            //         }
            //     }
            // );

             

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            buttons.push({
                title: 'Read Id Card',
                cssClass: 'read-idcard-button text-blue',
                icon: 'fa fa-id-card',
                separator: true,
                onClick: () => {
                    if (!this.validateBeforeSave())
                        return;
                        
                    Q.confirm("ยืนยันการอ่านบัตรประชาชน?", () => {
                        Q.notifyInfo("กำลังอ่านบัตรประชาชน... กรุณารอสักครู่");
    
                        fetch('http://localhost:4466/api/idcard/read')
                            .then(response => response.json())
                            .then(result => {
                                if (result.success) {
                                    const cardData = result.data[0];
                                    
                                    if (cardData) {
                                        // Set form values from card data
                                        this.form.MbPid.value = cardData.citizenID || '';
                                        this.form.MbNameT.value = cardData.thaiName || '';
                                        this.form.MbNameE.value = cardData.englishName || '';
                                        this.form.MbAddress.value = cardData.houseNo || '';
                                        this.form.MbLineAddr1.value = `${cardData.houseNo || ''} ${cardData.villageNo || ''} ${cardData.lane || ''} ${cardData.road || ''}`.trim();
                                        this.form.MbTumbol.value = cardData.tambol || '';
                                        this.form.MbAmphur.value = cardData.amphur || '';
                                        this.form.MbProvince.value = cardData.province || '';
                                        this.form.MbLineAddr2.value = `${cardData.tambol || ''} ${cardData.amphur || ''}`.trim();
                                        this.form.MbLineAddr3.value = cardData.province || '';
                                        this.form.MbBirthDay.value = cardData.birthDate || '';
                                        this.form.MbGender.value = cardData.sex ? (cardData.sex == '1' ? 'M' : 'F') : '';
                                        
                                        var id = Q.tryFirst(Member.LookupMemberRow.getLookup().items, x => x.MbPid == cardData.citizenID);
                                        console.log(id);
                                        if (id != null && this.entity.Id != id.Id) {
                                            Q.warning('มีข้อมูล สมาชิกนี้อยู่แล้ว โปรดตรวจสอบ');
                                            return;   
                                            
                                        }   
                   
                                        Q.notifySuccess('อ่านข้อมูลบัตรสำเร็จ');
                                    } else {
                                        Q.notifyError("ไม่พบข้อมูลบัตรประชาชน");
                                    }
                                } else {
                                    Q.notifyError(result.message);
                                }
                            })
                            .catch(error => {
                                Q.notifyError("เกิดข้อผิดพลาดในการเชื่อมต่อกับเครื่องอ่านบัตร: " + error.message);
                            });
                    });
                }
            });


            return buttons;
        }

        // protected onClickReadCard() {
        //     Q.notifyInfo("กำลังอ่านข้อมูลบัตรประชาชน...");

        //     // เปลี่ยนจาก PromiseLike เป็น Promise
        //     this.readThaiIDCard().then((data: any) => {
        //         this.sendToServer(data);
        //     });
        // }

        
        
        // protected readThaiIDCard(): PromiseLike<any> {
        //     return new Promise<any>((resolve, reject) => {
        //         try {
        //             if (typeof window !== "undefined" && "ActiveXObject" in window) {
        //             var reader = new (window as any).ActiveXObject("ThaiNationalIDCard.Reader");
        //             } else {
        //                 console.error("ActiveXObject ไม่รองรับในเบราว์เซอร์นี้");
        //             }
        //             let card = reader.readCard();

        //             if (card) {
        //                 resolve({
        //                     CitizenID: card.IdCardNumber,
        //                     ThaiName: card.ThaiPrefix + card.ThaiFirstName + " " + card.ThaiLastName,
        //                     EnglishName: card.EnglishFirstName + " " + card.EnglishLastName,
        //                     Address: card.Address,
        //                     BirthDate: card.BirthDate,
        //                     ExpireDate: card.ExpireDate,
        //                     HouseNo: card.addrHouseNo,
        //                     VillageNo: card.addrVillageNo,
        //                     Lane: card.addrLane,
        //                     Road: card.addrRoad,
        //                     Tambol: card.addrTambol,
        //                     Amphur: card.addrAmphur,
        //                     Province: card.addrProvince,
        //                     Sex: card.Sex
        //                 });
        //             } else {
        //                 reject("ไม่สามารถอ่านบัตรได้");
        //             }
        //         } catch (error) {
        //             reject("ไม่พบไดรเวอร์หรือเครื่องอ่านบัตรไม่ได้เชื่อมต่อ");
        //         }
        //     });
        // }
        
        
        protected sendToServer(cardData: any): void {
            Q.serviceRequest("~/Services/Csi/ThaiReadCard", cardData, 
            (response: any) => {
                if (response.Success) {

                    this.form.MbPid.value = response.CitizenID;
                    this.form.MbNameT.value = response.ThaiName;
                    this.form.MbNameE.value = response.EnglishName;
                    this.form.MbAddress.value = response.HouseNo;
                    this.form.MbLineAddr1.value = `${response.HouseNo} ${response.VillageNo} ${response.Lane} ${response.Road}`;
                    this.form.MbTumbol.value = response.Tambol;
                    this.form.MbAmphur.value = response.Amphur;
                    this.form.MbProvince.value = response.Province;
                    this.form.MbLineAddr2.value = `${response.Tambol} ${response.Amphur}`;
                    this.form.MbLineAddr3.value = response.Province;
                    this.form.MbBirthDay.value = response.BirthDate;
                    this.form.MbGender.value = response.Sex == '1' ? 'M' : 'F';

                    Q.notifySuccess('อ่านข้อมูลบัตรสำเร็จ');
                } else {
                    Q.notifyError(response.Message || 'เกิดข้อผิดพลาดในการอ่านบัตร');
                }
            });
        }
        
        

        private readCard() {
            Q.serviceCall({
                url: Q.resolveUrl('~/Services/Csi/ReadCard'),
                onSuccess: (response: any) => {
                    console.log(response);
                    if (response.CitizenID != null) {
                        // นำข้อมูลที่ได้มาใส่ในฟอร์มสมาชิก
                        let data = response;
                        console.log(data);
                        this.form.MbPid.value = data.CitizenID;
                        this.form.MbNameT.value = data.ThaiName;
                        this.form.MbNameE.value = data.EnglishName;
                        this.form.MbAddress.value = data.HouseNo;
                        this.form.MbLineAddr1.value = `${data.HouseNo} ${data.VillageNo} ${data.Lane} ${data.Road}`;
                        this.form.MbTumbol.value = data.Tambol;
                        this.form.MbAmphur.value = data.Amphur;
                        this.form.MbProvince.value = data.Province;
                        this.form.MbLineAddr2.value = `${data.Tambol} ${data.Amphur}`;
                        this.form.MbLineAddr3.value = data.Province;
                        this.form.MbBirthDay.value = data.BirthDate;
                        this.form.MbGender.value = data.Sex == '1' ? 'M' : 'F';
                        
                        var id = Q.tryFirst(Member.LookupMemberRow.getLookup().items, x => x.MbPid == data.CitizenID);
                        console.log(id);
                        if (id != null && this.entity.Id != id.Id) {
                            Q.warning('มีข้อมูล สมาชิกนี้อยู่แล้ว โปรดตรวจสอบ');
                            return;   
                            
                        }   
                   

                        Q.notifySuccess('อ่านข้อมูลบัตรสำเร็จ');
                    } else {
                        Q.notifyError(response.Error || 'เกิดข้อผิดพลาดในการอ่านบัตร');
                    }
                },
                onError: (response: any) => {
                    Q.notifyError(response.Error || 'เกิดข้อผิดพลาดในการอ่านบัตร');
                }
            });
        }


    }
}